function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.0609 12.8775V41.9346H32.092V26.037H16.4353V29.9696H28.1244V31.9992C28.1242 37.0761 28.116 42.1529 28.1292 47.2296C28.13 47.5458 28.1468 47.7976 28.1832 47.9964C32.6228 47.2725 36.6566 45.3468 39.9436 42.5638V22.1278C39.9436 19.0471 39.2605 15.6674 36.0609 12.8775Z",
  fill: "#FF2E4C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.1936 14.0905H32.1594V5.37542C34.5457 5.89249 43.5971 11.8123 43.966 21.0866V38.3127C46.8956 34.2961 48.6286 29.3509 48.6286 23.9988C48.6286 11.9094 39.8065 1.88475 28.2501 0C28.216 0.203994 28.2009 0.463484 28.1992 0.790525L28.1936 14.0905Z",
  fill: "#FF2E4C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4341 35.119V6.06185H16.4029V21.9594H32.0596V18.0269H20.3705V15.9973C20.3707 10.9204 20.3789 5.8435 20.3657 0.766797C20.365 0.450663 20.3481 0.198827 20.3118 0C15.8721 0.723931 11.8383 2.64963 8.55127 5.43264V25.8686C8.55127 28.9494 9.23444 32.3291 12.4341 35.119Z",
  fill: "#FF2E4C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.435 33.9095H16.4692V42.6246C14.0829 42.1075 5.03154 36.1877 4.66259 26.9134V9.68738C1.733 13.7039 0 18.6492 0 24.0012C0 36.0907 8.82209 46.1153 20.3786 48C20.4126 47.796 20.4278 47.5365 20.4295 47.2095L20.435 33.9095Z",
  fill: "#FF2E4C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M62.2661 34.5895V13.8045H65.4313V22.213H68.2656V13.8045H71.4307V34.5895H68.2656V24.9292H65.4313V34.5895H62.2661Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M84.686 28.3422L83.2922 17.9025H83.2452L81.9695 28.3422H84.686ZM78.1667 34.5895L81.1312 13.8045H85.3119L88.4652 34.5895H85.5126L85.0166 30.8812H81.6626L81.2136 34.5895H78.1667Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M95.137 34.5895V13.8045H97.617L102.022 26.2755L101.798 20.6069V13.8045H104.644V34.5895H102.4L97.8769 21.6816L98.0539 27.1376V34.5895H95.137Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M111.839 34.5895V13.8045H115.004V23.3704L118.169 13.8045H121.44L117.992 24.0553L121.712 34.5895H118.37L115.027 24.882V34.5895H111.839Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M130.938 31.3628C131.123 31.8431 131.503 32.0833 132.078 32.0833C132.653 32.0833 133.031 31.8372 133.212 31.345C133.393 30.8532 133.483 30.0087 133.483 28.8119V19.1281C133.483 18.144 133.391 17.4256 133.206 16.9728C133.021 16.5202 132.659 16.2937 132.119 16.2937C131.58 16.2937 131.202 16.5202 130.986 16.9728C130.769 17.4256 130.661 18.1401 130.661 19.1163V28.8119C130.661 30.0325 130.753 30.8827 130.938 31.3628ZM135.574 33.3232C134.849 34.3232 133.69 34.8231 132.096 34.8231C130.501 34.8231 129.332 34.3211 128.588 33.3174C127.844 32.3135 127.472 30.8 127.472 28.7765V19.2698C127.472 15.4593 129.027 13.5539 132.137 13.5539C133.743 13.5539 134.899 14.038 135.603 15.0065C136.308 15.9748 136.66 17.3961 136.66 19.2698V28.7765C136.66 30.8079 136.298 32.3235 135.574 33.3232Z",
  fill: "white"
});

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 48,
    viewBox: "0 0 137 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.96e398a1.svg";
export { ForwardRef as ReactComponent };